import Vue from 'vue'
import Loading from '@/components/StateWidgets/loading'
let LoadingConstructor = Vue.extend(Loading) // 返回扩展实例构造器

let myLoading = {}
let loadingDom = new LoadingConstructor({
  el: document.createElement('div') // 将loading组件挂载到新创建的div上
})
myLoading.show = (text) => {
  loadingDom.text = text
  document.body.appendChild(loadingDom.$el) // 把loading组件的dom加入body
  loadingDom.isShow = true
}
myLoading.hide = () => {
  loadingDom.isShow = false
}

export default myLoading